/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const SubGroup = zod.object({
  groupActorUuid: zod.uuid(),
  id: zod.string(),
  name: zod.string(),
  visibility: zod.enum(['PUBLIC', 'PRIVATE', 'SECRET']),
});

export type SubGroup = zod.input<typeof SubGroup>;
export type SubGroupOutput = zod.output<typeof SubGroup>;
